<template>
  <div
    :class="$style.root"
  >
    <core-text-component
      v-if="richText"
      :string="richText"
      :class="$style.richText"
    />
    <core-media-carousel-component
      v-if="videos"
      :videos="videos"
      :include-controls="includeControls"
      :include-nav="true"
    />
  </div>
</template>

<script setup lang="ts">
import { SwiperSlide } from 'swiper/vue'

const props = defineProps({
  videos: {
    type: Array
  },
  richText: {
    type: String,
    required: false
  },
  includeControls: {
    type: Boolean,
    default: false
  }
})
</script>

<style module>
.root {}

.richText {
  composes: font-size-small caption from global;
  margin-bottom: var(--unit--vertical);
}
</style>
